import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, timer } from 'rxjs';
import { switchMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class HomepageDataHelperService {
  private apiUrl = 'homepage';
  private dataSubject = new BehaviorSubject<any>(null);

  constructor(private http: HttpClient) {
    this.fetchHomepageData();
  }

  fetchHomepageData() {
    // this.http.get(this.apiUrl).subscribe((response: any) => {
    //   this.dataSubject.next(response.data);
    // });
  }

  startAutoRefresh() {
    // Refresh data every 60 seconds
    // timer(30 * 1000, 30 * 1000).pipe(
    //   switchMap(() => this.http.get(this.apiUrl))
    // ).subscribe((response: any) => {
    //   this.dataSubject.next(response.data);
    // });
  }

  getData() {
    return this.dataSubject.asObservable();
  }

  refreshData() {
    this.fetchHomepageData();
  }
}
